import { render } from "./UploadPanel.vue?vue&type=template&id=f406519e&scoped=true"
import script from "./UploadPanel.vue?vue&type=script&lang=js"
export * from "./UploadPanel.vue?vue&type=script&lang=js"

import "./UploadPanel.vue?vue&type=style&index=0&id=f406519e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f406519e"]])

export default __exports__